export default __webpack_public_path__ + "static/media/raki_detail4.d4dc987d.jpg";